import type { Contact } from '../contact';

/**
 * Canonical mock {@link Contact} used by tests, MSW handlers and the
 * demo build.
 */
export const MOCK_CONTACT: Contact = {
  id: 1,
  type: 'sales',
  first_name: 'John',
  last_name: 'Doe',
  email: 'john.doe@example.com',
  number: '+1 555-0100',
  has_whatsapp: true,
  country_id: 840,
  country_code: 'US',
  indutrustMainPoc: false,
};

/**
 * Builds a {@link Contact} from {@link MOCK_CONTACT} with optional
 * overrides.
 */
export function createMockContact(overrides?: Partial<Contact>): Contact {
  return { ...MOCK_CONTACT, ...overrides };
}

/**
 * Builds a list of mock {@link Contact} entries. IDs are auto-incremented
 * from `1` unless overridden via the per-index callback.
 */
export function createMockContactList(
  count = 3,
  overrideAt?: (index: number) => Partial<Contact>
): Contact[] {
  return Array.from({ length: count }, (_, i) =>
    createMockContact({
      id: i + 1,
      ...overrideAt?.(i),
    })
  );
}
